/* eslint-disable import/no-unresolved, import/prefer-default-export */
import { QrModalOptions } from '@walletconnect/ethereum-provider/dist/types/EthereumProvider'
import { SUPRA_MAINNET_CHAIN_ID } from 'config/constants/chains'
import { WalletConnect, WalletConnectConstructorArgs } from './WalletConnect'
import { rpcMap } from './providers'

export class WalletConnectPopup extends WalletConnect {
  constructor({
    actions,
    onError,
    qrcode = true,
    qrModalOptions,
  }: Omit<WalletConnectConstructorArgs, 'options'> & {
    qrcode?: boolean
    qrModalOptions?: QrModalOptions
  }) {
    super({
      actions,
      options: {
        showQrModal: qrcode,
        chains: [SUPRA_MAINNET_CHAIN_ID],
        projectId: '41abfb2d50aad725c4623d0324f59d83',
        qrModalOptions,
        rpcMap,
      },
      onError,
    })
  }

  activate(chainId?: number) {
    return super.activate(chainId)
  }
}
